import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import './NavLanguage.scss';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { changeLanguage } from '../../../redux/actions/user.action';

const { SubMenu } = Menu;

function NavLanguage({ user, mvp, changeLanguage }) {
  const [currentLanguage, setCurrentLanguage] = useState('vi');
  const [menuTitle, setMenuTitle] = useState('');
  const [listLanguage, setListLanguage] = useState([]);

  useEffect(() => {
    let language = localStorage.getItem('language') || 'vi';

    if (user.language) {
      language = user.language.value ?? user.language;
      setCurrentLanguage(language)
      localStorage.setItem('language', language)
    }
    if (mvp && mvp.listLanguage.length) {
      setListLanguage(mvp.listLanguage)
      const currentLanguage = mvp.listLanguage.find(lg => lg.value === language);
      setCurrentLanguage(currentLanguage.value)
      if (currentLanguage) {
        language = currentLanguage.label;
      }
      setMenuTitle(language);
    }
  }, [mvp.listLanguage, user.language]);

  const handleClick = async ({ key }) => {
    const language = listLanguage.find(lg => lg.value === key);

    if (!language) {
      return
    }
    setMenuTitle(language.label);
    localStorage.setItem('language', key)
    if (user.accessToken) {
      await changeLanguage(key)
    }
    // Đợi một chút để đảm bảo localStorage được lưu hoàn toàn
    setTimeout(() => {
      window.location.reload()
    }, 200)
  };

  return (
    <>
      {listLanguage.length ? <Menu
        onSelect={handleClick}
        defaultSelectedKeys={[currentLanguage]}
        className="menu-language"
        mode="horizontal"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        theme="dark"
      >
        <SubMenu
          key="sub1"
          title={menuTitle}
          icon={<FontAwesomeIcon icon={faAngleDown} />}
          popupClassName="submenu-language"
        >
          {listLanguage.map(language =>
            <Menu.Item key={language.value}>{language.label}</Menu.Item>
          )}
        </SubMenu>
      </Menu>: null}
    </>
  );
};

const mapStateToProps = ({ user, mvp }) => ({ user, mvp });
const mapDispatchToProps = {
  changeLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(NavLanguage);
